import WaveHand from "@/assets/openmoji/WaveHand";
import { commonComponents as cc } from "@/components/common";
import { ui } from "@patient-watch/ui";
import { selectFormByIdQueryOptions, useSelectFormById } from "@/features/forms/api/selectFormById";
import { useSelectFormImageById } from "@/features/forms/api/selectFormImageById";
import { useFormPageCopy } from "@/features/i18n/formPageCopy";
import { useAppLocale } from "@/features/i18n/LocaleProvider";
import { services as s } from "@/services";
import { Link, createFileRoute } from "@tanstack/react-router";

const Page = () => {
    const { trackerId, formId } = Route.useParams();
    const { locale } = useAppLocale();
    const copy = useFormPageCopy();
    const loaderForm = Route.useLoaderData().form;
    const { data: queriedForm } = useSelectFormById(formId, locale);
    const form = queriedForm ?? loaderForm;
    const { data: image } = useSelectFormImageById(form?.image_id ?? "");
    return (
        <section className="flex flex-col gap-4 max-w-lg">
            <cc.Title words={form?.form_name as string} description={form?.form_description ?? undefined} />
            {image?.publicUrl ? (
                <img className="flex mx-auto my-4 px-4 max-w-sm" src={image?.publicUrl} alt="Form Icon" />
            ) : (
                <WaveHand className="flex mx-auto w-32 h-32" />
            )}
            <ui.Button size="lg" asChild>
                <Link
                    className="my-4"
                    to="/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex"
                    params={{
                        trackerId: trackerId,
                        formId: formId,
                        entryId: s.uuidv4(),
                        pageIndex: "1",
                    }}
                >
                    {copy.startNow}
                </Link>
            </ui.Button>
        </section>
    );
};

export const Route = createFileRoute("/tracker/$trackerId/form/$formId/")({
    component: Page,
    loader: async ({ context, params }) => {
        const form = await context?.queryClient.ensureQueryData(selectFormByIdQueryOptions(params.formId));
        return { form };
    },
});
